import type { JSX, ReactNode } from 'react';

export function PoolShareRow({
  label,
  amount,
  sharePercent,
}: {
  label: string;
  amount: ReactNode;
  sharePercent: string;
}): JSX.Element {
  return (
    <div
      data-testid="pool-share-row"
      className="flex items-center justify-between rounded-panel-inset bg-background-tertiary/50 px-3 py-2"
    >
      <span className="text-body text-foreground-tertiary">{label}</span>
      <span className="text-body tabular-nums">
        <span data-testid="pool-share-amount" className="text-foreground-primary">
          {amount}
        </span>
        <span className="text-foreground-tertiary">{` • ${sharePercent}`}</span>
      </span>
    </div>
  );
}
